import React, {Component} from 'react';
import moment from 'moment-timezone';

export const TIMEZONE_OFFSET_MINUTES = moment().tz('Europe/Copenhagen').utcOffset();
export const DATE_FORMAT = 'DD-MM-YYYY';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export default class DateHelper {
    static getToday() {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
    }

    static getTomorrow() {
        let date = this.getToday();
        date.setDate(date.getDate()+1);
        return date;
    }

    /**
     * Get timestamp considering locale
     * @param {moment} momentTime
     *
     * @return integer
    * */
    static getUnixTimestampByTimezone(momentTime) {
        return momentTime.unix() + (momentTime.utcOffset() * 60) - (TIMEZONE_OFFSET_MINUTES * 60);
    }

    static getTomorrowTimestamp() {
        let momentTime = moment(DateHelper.getTomorrow());
        return DateHelper.getUnixTimestampByTimezone(momentTime);
    }

}


// WEBPACK FOOTER //
// ./web/src/components/helpers/DateHelper.jsx